const route = {
	"data": [
		{
			"id": "login",
			"type": "route",
			"attributes": {
				"url": "/register"
			}
		},
		{
			"id": "logout",
			"type": "route",
			"attributes": {
				"url": "/logout"
			}
		},
		{
			"id": "plugin.apex.ui.account.changepassword",
			"type": "route",
			"attributes": {
				"url": "/account/changepassword"
			}
		},
		{
			"id": "account.login.forgotpassword",
			"type": "route",
			"attributes": {
				"url": "/passwordrecovery"
			}
		},
		{
			"id": "plugin.apex.ui.store.patients",
			"type": "route",
			"attributes": {
				"url": "/store/patients"
			}
		},
		{
			"id": "plugin.apex.ui.store.orders",
			"type": "route",
			"attributes": {
				"url": "/store/orders"
			}
		},
		{
			"id": "plugin.apex.ui.store.reorder",
			"type": "route",
			"attributes": {
				"url": "/store/reorder"
			}
		},
		{
			"id": "plugin.apex.ui.account.order",
			"type": "route",
			"attributes": {
				"url": "/account/order"
			}
		},
		{
			"id": "plugin.apex.ui.orderdetails",
			"type": "route",
			"attributes": {
				"url": "/account/order/{0}"
			}
		},
		{
			"id": "plugin.apex.ui.store.account",
			"type": "route",
			"attributes": {
				"url": "/store/account"
			}
		},
		{
			"id": "plugin.apex.ui.store.practice",
			"type": "route",
			"attributes": {
				"url": "/store/practice"
			}
		},
		{
			"id": "plugin.apex.accountinfo.storesettings.returns",
			"type": "route",
			"attributes": {
				"url": "/customer/store/settings/returns"
			}
		},
		{
			"id": "plugin.apex.accountinfo.storesettings.salestax",
			"type": "route",
			"attributes": {
				"url": "/customer/store/settings/salestax"
			}
		},
		{
			"id": "plugin.apex.ui.account.catalog",
			"type": "route",
			"attributes": {
				"url": "/account/catalog"
			}
		},
		{
			"id": "plugin.apex.ui.store.coupons",
			"type": "route",
			"attributes": {
				"url": "/store/coupons"
			}
		},
		{
			"id": "plugin.apex.ui.store.coupons.edit",
			"type": "route",
			"attributes": {
				"url": "/coupon/edit/{0}"
			}
		},
		{
			"id": "plugin.apex.autoreorder.manage",
			"type": "route",
			"attributes": {
				"url": "/customer/reorder"
			}
		},
		{
			"id": "plugin.apex.autoreorder.manage.edit",
			"type": "route",
			"attributes": {
				"url": "/customer/reorder/update/?id={0}"
			}
		},
		{
			"id": "plugin.apex.ui.account.reorder",
			"type": "route",
			"attributes": {
				"url": "/account/reorder"
			}
		},
		{
			"id": "plugin.apex.ui.account.reorder.edit",
			"type": "route",
			"attributes": {
				"url": "/account/reorder/{0}"
			}
		},
		{
			"id": "plugin.apex.customprice.index",
			"type": "route",
			"attributes": {
				"url": ""
			}
		},
		{
			"id": "plugin.apex.ui.account.dashboard",
			"type": "route",
			"attributes": {
				"url": "/account/dashboard"
			}
		},
		{
			"id": "plugin.apex.ui.account.profile",
			"type": "route",
			"attributes": {
				"url": "/account/profile"
			}
		},
		{
			"id": "plugin.apex.ui.store.pricing",
			"type": "route",
			"attributes": {
				"url": "/store/pricing"
			}
		},
		{
			"id": "plugin.apex.payments.invoicedetail",
			"type": "route",
			"attributes": {
				"url": "/customer/myaccount/InvoiceDetail/{0}"
			}
		},
		{
			"id": "plugin.apex.ui.account.invoice",
			"type": "route",
			"attributes": {
				"url": "/account/invoice"
			}
		},
		{
			"id": "plugin.apex.ui.account.invoicedetail",
			"type": "route",
			"attributes": {
				"url": "/account/invoicedetail/{0}"
			}
		},
		{
			"id": "plugin.apex.ui.account.invoicepayment",
			"type": "route",
			"attributes": {
				"url": "/account/invoicepayment"
			}
		},
		{
			"id": "plugin.apex.ui.account.invoicepaymentconfirmation",
			"type": "route",
			"attributes": {
				"url": "/account/invoicepaymentconfirmation"
			}
		},
		{
			"id": "plugin.apex.payments.invoicepayment",
			"type": "route",
			"attributes": {
				"url": "/customer/myaccount/InvoicePayment"
			}
		},
		{
			"id": "plugin.apex.ui.account.return",
			"type": "route",
			"attributes": {
				"url": "/account/return"
			}
		},
		{
			"id": "plugin.apex.ui.account.returndetail",
			"type": "route",
			"attributes": {
				"url": "/account/returndetail/{0}"
			}
		},
		{
			"id": "plugin.apex.ui.account.payment",
			"type": "route",
			"attributes": {
				"url": "/account/payment"
			}
		},
		{
			"id": "plugin.apex.ui.account.message",
			"type": "route",
			"attributes": {
				"url": "/account/message"
			}
		},
		{
			"id": "plugin.apex.ui.account.messagedetail",
			"type": "route",
			"attributes": {
				"url": "/account/message/{0}"
			}
		},
		{
			"id": "plugin.apex.ui.account.savedcart",
			"type": "route",
			"attributes": {
				"url": "/account/savedcart"
			}
		},
		{
			"id": "plugin.apex.ui.account.wallet",
			"type": "route",
			"attributes": {
				"url": "/account/wallet"
			}
		},
		{
			"id": "plugin.apex.ui.account.address",
			"type": "route",
			"attributes": {
				"url": "/account/address"
			}
		},
		{
			"id": "plugin.apex.ui.store.products",
			"type": "route",
			"attributes": {
				"url": "/store/products"
			}
		},
		{
			"id": "plugin.apex.ui.register.practitioner",
			"type": "route",
			"attributes": {
				"url": "/register/practitioner"
			}
		},
		{
			"id": "plugin.apex.ui.checkout",
			"type": "route",
			"attributes": {
				"url": "/checkout"
			}
		},
		{
			"id": "plugin.apex.ui.cart",
			"type": "route",
			"attributes": {
				"url": "/cart"
			}
		}
	]
}

export { route as default }
